import { styled, AppBar as MuiAppBar, AppBarProps as MuiAppBarProps } from '@mui/material';
import {
	APP_BAR_HEIGHT,
	getNavDrawerCollapsedWidth,
	NAV_DRAWER_WIDTH,
} from 'shared/_components/app-layout/constants';

type AppBarProps = MuiAppBarProps & { expanded: boolean, open: boolean };

export const AppBarStyled = styled(MuiAppBar, {
	shouldForwardProp: (prop: string) => !['expanded', 'open'].includes(prop),
})<AppBarProps>(({ theme, expanded }) => ({
	// zIndex: theme.zIndex.drawer + 1,
	height: APP_BAR_HEIGHT,
	transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	boxShadow: 'none',
	textAlign: 'center',
	borderBottom: `1px solid ${theme.palette.divider}`,
	width: `100%`,
	[theme.breakpoints.up('sm')]: {
		marginLeft: expanded ? undefined : NAV_DRAWER_WIDTH,
		transition: expanded
			? theme.transitions.create(['width', 'margin'], {
					easing: theme.transitions.easing.sharp,
					duration: theme.transitions.duration.enteringScreen,
			  }) : undefined,
		width: expanded
			? `calc(100% - ${NAV_DRAWER_WIDTH}px)`
			: `calc(100% - ${getNavDrawerCollapsedWidth(theme, 'sm')})`,
	},
	// ...(!expanded && {
	// 	width: `calc(100% - ${getNavDrawerCollapsedWidth(theme, 'xs')})`,
	// 	[theme.breakpoints.up('sm')]: {
	// 		width: `calc(100% - ${getNavDrawerCollapsedWidth(theme, 'sm')})`,
	// 	},
	// }),
	// ...(expanded && {
	// 	marginLeft: NAV_DRAWER_WIDTH,
	// 	width: `calc(100% - ${NAV_DRAWER_WIDTH}px)`,
	// 	transition: theme.transitions.create(['width', 'margin'], {
	// 		easing: theme.transitions.easing.sharp,
	// 		duration: theme.transitions.duration.enteringScreen,
	// 	}),
	// }),
}));
